import { render } from "./StepForm4.vue?vue&type=template&id=5825061f&scoped=true"
import script from "./StepForm4.vue?vue&type=script&lang=js"
export * from "./StepForm4.vue?vue&type=script&lang=js"

import "./StepForm4.vue?vue&type=style&index=0&id=5825061f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5825061f"]])

export default __exports__